import { debounce } from 'lodash';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';

const useSearchHandler = (props?: { customSearchKey: undefined | string }) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleSearch = debounce((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const params = new URLSearchParams(searchParams);

    if (value) {
      params.set((props && props?.customSearchKey) || 'searchTerm', value);
    } else {
      params.delete((props && props?.customSearchKey) || 'searchTerm');
    }

    replace(`${pathname}?${params.toString()}`, {
      scroll: false,
    });
  }, 500);

  const searchValue = searchParams.get('search')?.toString();

  return { handleSearch, searchValue };
};

export default useSearchHandler;
